export default __webpack_public_path__ + "static/media/eWallet.5e1d1384.svg";